import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
// import FloatingLabelInput from "react-floating-label-input";
import { requestOtp } from "../Request/LoginRequests";
// import { handleInput, handleKeyPress } from "../Others/eventHandlers";
import Input from "../Others/Input";
// import SplashBg from "../img/splashbg.jpg";
import infoIcon from "../img/info-icon.png";

/**
 * React Functional Component
 * @param {String} phn Phone no. passed from top component
 * @param {Function} setPhn Set phone no.
 * @returns {JSX}
 */
export default function Login({ phn, setPhn }) {
  const { t } = useTranslation();
  const [load, setLoad] = useState(false);

  // Request an otp
  function handleSendOtp() {
    setLoad(true); // set state to loading

    requestOtp(phn) // otp request
      .then(() => {
        //toast.success("OTP sent");
        // Hide login and show verify
        document.getElementById("login").classList.toggle("hide");
        document.getElementById("countStart").click();
        document.getElementById("verify").classList.toggle("hide");
        document.getElementById("enterOTP").focus();
        document.getElementById("receiveOTP").classList.toggle("d-none");
        document.getElementById("resendOTP").classList.toggle("d-none");
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoad(false));
  }

  return (
    // Login Popup
    <div
      className="bg-white overflow-hidden animate "
      style={{
        padding: "42px 16px 0",
        transition: "ease 0.5s",
        width: "100vw",
        height: "100vh",
        position: "relative",
      }}
      id="login"
    >
      {/* Header */}
      <h2
        style={{
          fontSize: "24px",
          fontWeight: "700",
          margin: "0 0 22px",
          color: "#2B2B2B",
        }}
      >
        {t("Login")}
      </h2>

      <div className="bg-white">
        {/* Phone no input */}
        <div
          className="overflow-hidden mb-2"
          style={{ background: "#F9F9F9", borderRadius: "4px" }}
        >
          <Input
            label={t("Enter Mobile Number")}
            placeholder=""
            id="phoneNo"
            style={{
              padding: "0 10px 10px",
              position: "relative",
              fontSize: "12px",
            }}
            dotPrecision={0}
            isAllowed={({ value }) =>
              (value > 5 && value < Math.pow(10, 10)) || value === ""
            }
            value={phn}
            onChange={(e) => setPhn(e.target.value)}
          />
          {/* <FloatingLabelInput
            id="phn"
            type="number"
            label="Enter Mobile No."
            className="fs-5 floating-label"
            placeholder="Enter 10-digit Mobile No."
            value={phn}
            onKeyDown={(e) => handleKeyPress(e, phn, 10)}
            onChange={(e) => handleInput(e, setPhn)}
          /> */}
        </div>

        <div
          className="d-flex align-items-center"
          style={{
            borderRadius: "8px",
            background: "#FEF5EB",
            color: "#2B2B2B",
            padding: "4px 6px",
            fontWeight: "500",
            fontSize: "12px",
            lineHeight: "16px",
            marginBottom: "24px",
          }}
        >
          <img
            src={infoIcon}
            alt=""
            width={16}
            style={{ marginRight: "4px" }}
          />
          {t("Get order updates on WhatsApp, SMS & Notifications")}
        </div>

        <div className="d-flex">
          {/* Login Button */}
          <button
            className="btn-cnf btn-orange w-100 animate-2"
            disabled={load || !/^[6-9]{1}[0-9]{9}$/.test(phn)}
            onClick={handleSendOtp}
          >
            {load ? t("Sending...") : t("Continue")}
          </button>

          {/* Without Login */}
          {/* <button
            className="btn-cnf btn-aqua py-2 w-100 fs-5"
            onClick={() => {
              // Hide login and show location popup
              document.getElementById("pin").classList.toggle("hide");
              document.getElementById("login").classList.toggle("hide");
            }}
          >
            Use Pincode
          </button> */}

          <div
            style={{
              position: "absolute",
              bottom: "16px",
              left: "16px",
              right: "16px",
              fontSize: "12px",
              textAlign: "center",
              lineHeight: "150%",
              color: "#666666",
              fontWeight: "300",
            }}
          >
            {t("By Logging In, I agree to")}{" "}
            <a
              href="#"
              style={{
                color: "#2278FF",
                textDecoration: "none",
                fontSize: "12px",
              }}
            >
              {t("Terms & Conditions")}
            </a>{" "}
            <br />
            {t("and")}
            <a
              href="#"
              style={{
                color: "#2278FF",
                textDecoration: "none",
                fontSize: "12px",
              }}
            >
              {t("Privacy Policy")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
